import { createReducer } from 'reduxsauce'
import importer from 'common/importer'

const { INITIAL_STATE } = importer('Stores/AuthCustom/InitialState', null)
const { AuthCustomTypes } = importer('Stores/AuthCustom/Actions', null)
const loginLoading = (state) => ({
  ...state,
  loginLoading: true,
  loginSuccess: null,
  loginFailure: null
})

const loginSuccess = (state, { res }) => ({
  ...state,
  loginLoading: false,
  loginSuccess: res,
  loginFailure: null
})

const loginFailure = (state, { error }) => ({
  ...state,
  loginLoading: false,
  loginSuccess: null,
  loginFailure: error
})

//

const loginAuthLoading = (state) => ({
  ...state,
  loginAuthLoading: true,
  loginAuthSuccess: null,
  loginAuthFailure: null
})
const loginAuthSuccess = (state, { res }) => ({
  ...state,
  loginAuthLoading: false,
  loginAuthSuccess: res,
  loginAuthFailure: null
})
const loginAuthFailure = (state, { error }) => ({
  ...state,
  loginAuthLoading: false,
  loginAuthSuccess: null,
  loginAuthFailure: error
})

//

const loginTokenExchangeLoading = (state) => ({
  ...state,
  loginTokenExchangeLoading: true,
  loginTokenExchangeSuccess: null,
  loginTokenExchangeFailure: null
})

const loginTokenExchangeSuccess = (state, { res }) => ({
  ...state,
  loginTokenExchangeLoading: false,
  loginTokenExchangeSuccess: res,
  loginTokenExchangeFailure: null
})
const loginTokenExchangeFailure = (state, { error }) => ({
  ...state,
  loginTokenExchangeLoading: false,
  loginTokenExchangeSuccess: null,
  loginTokenExchangeFailure: error
})

//

const loginHerokuLoading = (state) => ({
  ...state,
  loginHerokuLoading: true,
  loginHerokuSuccess: null,
  loginHerokuFailure: null
})
const loginHerokuSuccess = (state, { res }) => ({
  ...state,
  user: res,
  loginHerokuLoading: false,
  loginHerokuSuccess: res,
  loginHerokuFailure: null
})
const loginHerokuFailure = (state, { error }) => ({
  ...state,
  loginHerokuLoading: false,
  loginHerokuSuccess: null,
  loginHerokuFailure: error
})

//

const logoutLoading = (state) => ({
  ...state,
  logoutLoading: true,
  logoutSuccess: null,
  logoutFailure: null
})

const logoutSuccess = (state, { res }) => ({
  ...state,
  logoutLoading: false,
  logoutSuccess: res,
  logoutFailure: null
})

const logoutFailure = (state, { error }) => ({
  ...state,
  logoutLoading: false,
  logoutSuccess: null,
  logoutFailure: error
})

/* GET SESSION */

const getSessionLoading = (state) => ({
  ...state,
  getSessionLoading: true,
  getSessionSuccess: null,
  getSessionFailure: null
})
const getSessionSuccess = (state, { res }) => ({
  ...state,
  session: res,
  getSessionLoading: false,
  getSessionSuccess: res,
  getSessionFailure: null
})
const getSessionFailure = (state, { error }) => ({
  ...state,
  session: null,
  getSessionLoading: false,
  getSessionSuccess: null,
  getSessionFailure: error
})

/* GET USER FROM SESSION */

const getSessionUserLoading = (state) => ({
  ...state,
  getSessionUserLoading: true,
  getSessionUserSuccess: null,
  getSessionUserFailure: null
})
const getSessionUserSuccess = (state, { res }) => ({
  ...state,
  getSessionUserLoading: false,
  getSessionUserSuccess: res,
  getSessionUserFailure: null
})
const getSessionUserFailure = (state, { error }) => ({
  ...state,
  getSessionUserLoading: false,
  getSessionUserSuccess: null,
  getSessionUserFailure: error
})

/* CHANGE PASSWORD */

const changePasswordLoading = (state) => ({
  ...state,
  changePasswordLoading: true,
  changePasswordSuccess: null,
  changePasswordFailure: null
})
const changePasswordSuccess = (state, { res }) => ({
  ...state,
  changePasswordLoading: false,
  changePasswordSuccess: res,
  changePasswordFailure: null
})
const changePasswordFailure = (state, { error }) => ({
  ...state,
  changePasswordLoading: false,
  changePasswordSuccess: null,
  changePasswordFailure: error
})

/* CHANGE RECOVERY QUESTION */

const changeRecoveryQuestionLoading = (state) => ({
  ...state,
  changeRecoveryQuestionLoading: true,
  changeRecoveryQuestionSuccess: null,
  changeRecoveryQuestionFailure: null
})
const changeRecoveryQuestionSuccess = (state, { res }) => ({
  ...state,
  changeRecoveryQuestionLoading: false,
  changeRecoveryQuestionSuccess: res,
  changeRecoveryQuestionFailure: null
})
const changeRecoveryQuestionFailure = (state, { error }) => ({
  ...state,
  changeRecoveryQuestionLoading: false,
  changeRecoveryQuestionSuccess: null,
  changeRecoveryQuestionFailure: error
})

/* FORGOT PASSWORD */

const forgotPasswordLoading = (state) => ({
  ...state,
  forgotPasswordLoading: true,
  forgotPasswordFailure: null
})
const forgotPasswordSuccess = (state, { res }) => ({
  ...state,
  forgotPasswordLoading: false,
  forgotPasswordSuccess: res,
  forgotPasswordFailure: null
})
const forgotPasswordFailure = (state, { error }) => ({
  ...state,
  forgotPasswordLoading: false,
  forgotPasswordSuccess: null,
  forgotPasswordFailure: error
})

/* CONTINUE SESSION */

const sessionRefreshLoading = (state) => ({
  ...state,
  sessionRefreshLoading: true,
  sessionRefreshSuccess: null,
  sessionRefreshFailure: null
})
const sessionRefreshSuccess = (state, { res }) => ({
  ...state,
  sessionRefreshLoading: false,
  sessionRefreshSuccess: res,
  sessionRefreshFailure: null
})
const sessionRefreshFailure = (state, { error }) => ({
  ...state,
  sessionRefreshLoading: false,
  sessionRefreshSuccess: null,
  sessionRefreshFailure: error
})

const registerLoading = (state) => ({
  ...state,
  registerLoading: true,
  registerSuccess: null,
  registerFailure: null
})
const registerSuccess = (state, { res }) => ({
  ...state,
  registerLoading: false,
  registerSuccess: res,
  registerFailure: null
})
const registerFailure = (state, { error }) => ({
  ...state,
  registerLoading: false,
  registerSuccess: null,
  registerFailure: error
})

const saveSignUp = (state, { user }) => ({
  ...state,
  registerSignUp: user
})
const saveCreateProfile = (state, { profile }) => ({
  ...state,
  registerCreateProfile: profile
})

export const reducer = createReducer(INITIAL_STATE, {
  [AuthCustomTypes.LOGIN_LOADING]: loginLoading,
  [AuthCustomTypes.LOGIN_SUCCESS]: loginSuccess,
  [AuthCustomTypes.LOGIN_FAILURE]: loginFailure,

  [AuthCustomTypes.LOGIN_AUTH_LOADING]: loginAuthLoading,
  [AuthCustomTypes.LOGIN_AUTH_SUCCESS]: loginAuthSuccess,
  [AuthCustomTypes.LOGIN_AUTH_FAILURE]: loginAuthFailure,

  [AuthCustomTypes.LOGIN_HEROKU_LOADING]: loginHerokuLoading,
  [AuthCustomTypes.LOGIN_HEROKU_SUCCESS]: loginHerokuSuccess,
  [AuthCustomTypes.LOGIN_HEROKU_FAILURE]: loginHerokuFailure,

  [AuthCustomTypes.LOGIN_TOKEN_EXCHANGE_LOADING]: loginTokenExchangeLoading,
  [AuthCustomTypes.LOGIN_TOKEN_EXCHANGE_SUCCESS]: loginTokenExchangeSuccess,
  [AuthCustomTypes.LOGIN_TOKEN_EXCHANGE_FAILURE]: loginTokenExchangeFailure,

  [AuthCustomTypes.REGISTER_LOADING]: registerLoading,
  [AuthCustomTypes.REGISTER_SUCCESS]: registerSuccess,
  [AuthCustomTypes.REGISTER_FAILURE]: registerFailure,

  [AuthCustomTypes.SAVE_SIGN_UP]: saveSignUp,
  [AuthCustomTypes.SAVE_CREATE_PROFILE]: saveCreateProfile,

  [AuthCustomTypes.LOGOUT_LOADING]: logoutLoading,
  [AuthCustomTypes.LOGOUT_SUCCESS]: logoutSuccess,
  [AuthCustomTypes.LOGOUT_FAILURE]: logoutFailure,

  [AuthCustomTypes.GET_SESSION_LOADING]: getSessionLoading,
  [AuthCustomTypes.GET_SESSION_SUCCESS]: getSessionSuccess,
  [AuthCustomTypes.GET_SESSION_FAILURE]: getSessionFailure,

  [AuthCustomTypes.GET_SESSION_USER_LOADING]: getSessionUserLoading,
  [AuthCustomTypes.GET_SESSION_USER_SUCCESS]: getSessionUserSuccess,
  [AuthCustomTypes.GET_SESSION_USER_FAILURE]: getSessionUserFailure,

  [AuthCustomTypes.CHANGE_PASSWORD_LOADING]: changePasswordLoading,
  [AuthCustomTypes.CHANGE_PASSWORD_SUCCESS]: changePasswordSuccess,
  [AuthCustomTypes.CHANGE_PASSWORD_FAILURE]: changePasswordFailure,

  [AuthCustomTypes.CHANGE_RECOVERY_QUESTION_LOADING]: changeRecoveryQuestionLoading,
  [AuthCustomTypes.CHANGE_RECOVERY_QUESTION_SUCCESS]: changeRecoveryQuestionSuccess,
  [AuthCustomTypes.CHANGE_RECOVERY_QUESTION_FAILURE]: changeRecoveryQuestionFailure,

  [AuthCustomTypes.FORGOT_PASSWORD_LOADING]: forgotPasswordLoading,
  [AuthCustomTypes.FORGOT_PASSWORD_SUCCESS]: forgotPasswordSuccess,
  [AuthCustomTypes.FORGOT_PASSWORD_FAILURE]: forgotPasswordFailure,

  [AuthCustomTypes.SESSION_REFRESH_LOADING]: sessionRefreshLoading,
  [AuthCustomTypes.SESSION_REFRESH_SUCCESS]: sessionRefreshSuccess,
  [AuthCustomTypes.SESSION_REFRESH_FAILURE]: sessionRefreshFailure
})
